import Schema from './Schema'
import FieldMultiSelect from '../fields/FieldMultiSelect'
export default class SchemaInput extends Schema {
  constructor(label, key, items, rules, options, on) {
    super(options)
    FieldMultiSelect.call(this, label, key, items, rules, options, on)
  }
}



// WEBPACK FOOTER //
// ./packages/helper/schema/SchemaMultiSelect.js